var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 262,
    viewBox: "0 0 380 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_authentication_fsn5",
    transform: "translate(0 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M231.848,83.176c-24.357.033-47.8-6.873-70.228-14.544S116.943,52.37,93.039,48.73C77.665,46.39,60.183,46.605,48.166,55.1,36.6,63.274,33.248,76.8,31.632,89.3c-1.215,9.4-1.776,19.269,2.776,27.869,3.161,5.97,8.57,10.891,12.382,16.581,13.308,19.794,5.3,45.079-7.628,65.332-6.064,9.5-13.168,18.611-17.752,28.658s-6.465,21.44-1.789,31.356c4.634,9.829,15.1,16.962,26.332,21.834,22.81,9.913,49.367,12.038,75.21,12.856C178.37,295.6,235.687,291.9,292.851,288.2c21.154-1.369,42.4-2.747,63.121-6.713,11.5-2.2,23.347-5.465,31.5-12.621,10.352-9.086,12.47-23.92,4.937-34.582-12.633-17.884-45.945-21.257-55-40.608-5-10.653-.688-22.87,5.657-33.139,13.608-22.033,37.03-41.768,37.424-66.411.27-16.923-11.91-33.432-30.1-40.787-19.069-7.7-45.069-5.722-58.428,8.636C278.22,76.762,253.354,83.153,231.848,83.176Z",
    transform: "translate(-16.91 -47.46)",
    fill: "#1890ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M992.766,689.813s-3.916-2.584-7.8-.746c0,0,1.195,2.3,6.108,2.084Z",
    transform: "translate(-668.091 -479.768)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M1005.449,693.25s1.192,4.537-1.8,7.624c0,0-1.8-1.87,0-6.452Z",
    transform: "translate(-680.276 -481.991)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M1007.024,673.51s-.29-3.858-9-2.577c0,0-.041,2.488,3.017,3.667S1005.5,674.785,1007.024,673.51Z",
    transform: "translate(-676.983 -467.777)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M1022.536,679.5s3.683,1.182.4,9.354c0,0-2.431-.542-2.868-3.795S1020.924,680.685,1022.536,679.5Z",
    transform: "translate(-691.947 -473.643)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M1025.436,650.03s.5-6.35-8.4-5.7c0,0-.637,5.735,6.834,7.226Z",
    transform: "translate(-689.927 -449.933)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M1040.262,628.16s-1.22-7.2-10.122-5.053c0,0-.032,6.222,8.669,6.767Z",
    transform: "translate(-698.869 -435.385)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M1052.175,605.216s-2.045-7.009-10.865-4.913c0,0,2.1,6.3,10.278,6.206Z",
    transform: "translate(-706.48 -420.021)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M1065.744,582.069s-2-7.274-10.514-5.1c0,0,2.842,6.91,9.95,6.327Z",
    transform: "translate(-715.965 -404.274)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M1076.225,556.838s-1.536-8.9-9.475-6.926c0,0,2.307,8.092,8.892,8.223Z",
    transform: "translate(-723.815 -386.083)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M1083.117,531.555s-1.845-8.965-9.877-6.372c0,0,3.148,8.475,9.306,7.6Z",
    transform: "translate(-728.237 -369.288)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M1089.458,503.256s-2.928-8.969-9.138-8.726c0,0,2.992,9.472,8.618,10.514Z",
    transform: "translate(-733.061 -348.901)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M1094.459,476.845s-3.186-10.794-8.239-9.963c0,0,2.2,8.252,8.061,11.645Z",
    transform: "translate(-737.082 -330.218)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M1096.785,449.994s-2.989-8.994-7.965-9.354c0,0,2.033,8.851,7.866,11.693Z",
    transform: "translate(-738.853 -312.555)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M1100.719,423.948s-3.724-9-7.009-9.208c0,0,1.619,8.867,6.691,10.686Z",
    transform: "translate(-742.185 -295.104)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M1105.062,396.47s-2.291-9.778-5.582-10.59c0,0,.449,8,5.251,11.323Z",
    transform: "translate(-746.117 -275.639)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M1110.045,367.784s-2.409-7.8-5.075-8.984c0,0,.526,9.192,4.461,10.89Z",
    transform: "translate(-749.858 -257.384)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M1119.842,336.6l.484-13.744s-4.986,10.361-.844,16.156Z",
    transform: "translate(-758.626 -233.109)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M1132.061,300.427s3.591-10.036,4.46-10.6c0,0-7.041,6.512-6.353,14.888Z",
    transform: "translate(-766.996 -210.853)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M1041.113,662.127s6.315-.825,6.127,8.1c0,0-5.706.93-7.57-6.452Z",
    transform: "translate(-705.363 -461.936)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M1059.736,639.06s7.3-.022,6.691,9.112c0,0-6.127,1.1-8.147-7.385Z",
    transform: "translate(-718.044 -446.378)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M1074.376,617.144s6.624-3.106,10.861,4.913c0,0-6.117,2.587-11.448-3.616Z",
    transform: "translate(-728.612 -431.252)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M1087.491,592.57s6.783-3.3,10.766,4.527c0,0-7.067,2.434-11.327-3.288Z",
    transform: "translate(-737.565 -414.617)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1095.579,566.987s6.528-6.235,11.737.07c0,0-6.668,5.133-12.037,1.319Z",
    transform: "translate(-743.255 -395.978)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1102.576,539.645s6.566-6.372,11.734.293c0,0-7.369,5.235-11.97,1.045Z",
    transform: "translate(-748.066 -377.538)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1106.93,507.344s5.059-7.965,11.017-6.187c0,0-5.251,8.433-10.96,8.057Z",
    transform: "translate(-751.193 -353.227)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1111.331,479.937s5.1-10.029,9.921-8.284c0,0-3.677,7.71-10.052,9.975Z",
    transform: "translate(-754.103 -333.347)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M1111.63,453.364s5.241-7.895,10.151-6.929c0,0-4.285,8.006-10.661,9.214Z",
    transform: "translate(-754.048 -316.435)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M1114,424.011s4.062-8.86,7.363-8.921c0,0-1.95,8.8-7.089,10.424Z",
    transform: "translate(-756.011 -295.343)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M1116.5,399.291s4.515-8.972,7.908-8.991c0,0-2.31,7.672-7.758,9.778Z",
    transform: "translate(-757.714 -278.634)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M1118.63,371.084s3.377-7.423,6.175-8.264c0,0-1.689,9.048-5.8,10.233Z",
    transform: "translate(-759.166 -260.101)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M1123.032,340.558l7.548-11.5s-1.934,11.342-8.65,13.7Z",
    transform: "translate(-761.414 -237.309)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M1133.834,310.961s8.771-6.053,9.09-7.031c0,0-4.461,8.478-12.744,9.975Z",
    transform: "translate(-767.036 -220.395)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M1142.782,296.763s10.071-9.682,12.642-9.673a16.44,16.44,0,0,0-12.885,9.156Z",
    transform: "translate(-775.458 -209.042)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M1118.94,339.9l.366.048c1.893-14.812,4.652-23.576,7.768-24.65l-.121-.35C1123.649,316.1,1120.871,324.728,1118.94,339.9Z",
    transform: "translate(-759.377 -227.702)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M1110.2,426.341l.554.045c.118-1.383.207-2.8.268-4.209.529-12.26,1.348-23.519,2.425-31.958l-.319-.4c-1.08,8.459-2.131,20.056-2.66,32.334C1110.407,423.556,1110.318,424.964,1110.2,426.341Z",
    transform: "translate(-753.422 -278.013)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M976.359,569.268c.1-.041,9.854-4.4,19.983-14.792a80.359,80.359,0,0,0,14.608-20.709c4.683-9.536,7.538-21.254,8.494-32.637l-.577.271c-2.151,25.551-13.783,43.011-23.032,52.521-10.03,10.3-19.68,14.614-19.776,14.655Z",
    transform: "translate(-662.019 -352.363)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M404.115,132.69H89.671a2.765,2.765,0,0,0-2.8,2.727v7.946H406.916v-7.946A2.765,2.765,0,0,0,404.115,132.69Z",
    transform: "translate(-64.58 -105.54)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M86.87,166.19V350.351a5.656,5.656,0,0,0,5.648,5.664h308.75a5.656,5.656,0,0,0,5.648-5.663V166.19Z",
    transform: "translate(-64.58 -128.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 1.274,
    cy: 1.274,
    rx: 1.274,
    ry: 1.274,
    transform: "translate(25.95 31.132)",
    fill: "#fa5959",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 1.274,
    cy: 1.274,
    rx: 1.274,
    ry: 1.274,
    transform: "translate(29.455 31.132)",
    fill: "#fed253",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 1.274,
    cy: 1.274,
    rx: 1.274,
    ry: 1.274,
    transform: "translate(32.96 31.132)",
    fill: "#8ccf4d",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 250.424,
    height: 110.114,
    transform: "translate(51.254 70.186)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 246.6,
    height: 107.686,
    transform: "translate(53.166 71.01)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M342.313,349.38a24.532,24.532,0,1,0,24.533,24.532A24.532,24.532,0,0,0,342.313,349.38Zm4.4,25.121v11.616H338.04V374.5a7.185,7.185,0,1,1,8.672,0Z",
    transform: "translate(-219.409 -250.635)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M342.313,349.38a24.532,24.532,0,1,0,24.533,24.532A24.532,24.532,0,0,0,342.313,349.38Zm4.4,25.121v11.616H338.04V374.5a7.185,7.185,0,1,1,8.672,0Z",
    transform: "translate(-219.409 -250.635)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M327.322,327.38a31.541,31.541,0,1,0,31.542,31.541A31.542,31.542,0,0,0,327.322,327.38Zm5.655,32.3v14.933H321.826V359.679a9.239,9.239,0,1,1,11.151,0Z",
    transform: "translate(-204.496 -235.659)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 101.954,
    height: 10.832,
    transform: "translate(170.168 119.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 21.984,
    height: 10.832,
    transform: "translate(250.888 139.395)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M556.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.162.162,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.318,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H556.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-377.441 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M577.4,425.11h-1.845l1.641-1.638a.163.163,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.162.162,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.163.163,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.163.163,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.318,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.163.163,0,0,0,0-.226l-1.641-1.641H577.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-391.596 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M598.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H598.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-405.751 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M619.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.162.162,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.163.163,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H619.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-419.907 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M640.4,425.11h-1.845l1.641-1.638a.163.163,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.163.163,0,0,0,0-.226l-1.641-1.641H640.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-434.062 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M661.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.163.163,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H661.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-448.217 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M682.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H682.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-462.372 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M703.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H703.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-476.527 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M724.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.162.162,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.163.163,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H724.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-490.682 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M745.4,425.11h-1.845l1.641-1.638a.163.163,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.162.162,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.163.163,0,0,0,0-.226l-1.641-1.641H745.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-504.837 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M766.4,425.11h-1.845l1.641-1.638a.162.162,0,0,0,0-.226.159.159,0,0,0-.226,0l-1.641,1.641v-1.848a.159.159,0,0,0-.159-.159.163.163,0,0,0-.159.159v1.848l-1.638-1.65a.159.159,0,0,0-.226,0,.162.162,0,0,0,0,.226l1.641,1.638h-1.848a.162.162,0,0,0-.159.159.159.159,0,0,0,.159.159h1.848l-1.641,1.641a.162.162,0,0,0,0,.226.166.166,0,0,0,.226,0l1.638-1.641v1.845a.159.159,0,1,0,.319,0v-1.845l1.641,1.641a.166.166,0,0,0,.226,0,.162.162,0,0,0,0-.226l-1.641-1.641H766.4a.155.155,0,1,0,0-.309Z",
    transform: "translate(-518.992 -300.655)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M833.817,494.172a5.71,5.71,0,0,0-.143-1.144c-.287-1.077-.934-2.38-2-2.7a16.767,16.767,0,0,1-3.167-1.338c-.191-3.415.593-6.91-.261-10.221a26.015,26.015,0,0,1-.985-3.61c-.175-1.542.245-3.186-.37-4.607a4.547,4.547,0,0,0-2.692-2.326,14.347,14.347,0,0,0-3.591-.637c-1.529-.124-6.48-.71-8.207.656h0a1.8,1.8,0,0,0-.318.319h0a1.274,1.274,0,0,0-.1.166l-.016.025a1.307,1.307,0,0,0-.086.207h0a1.616,1.616,0,0,0-.054.239v.573c.022.287.064.573.064.857a1.85,1.85,0,0,1-.038.421,2.946,2.946,0,0,1-.529,1.032h0l-.057.083c-.035.051-.07.1-.1.15s-.057.089-.083.134-.051.073-.073.115a1.552,1.552,0,0,0-.083.162c0,.032-.035.06-.048.092a1.563,1.563,0,0,0-.1.268,1.777,1.777,0,0,0-.019.847,3.155,3.155,0,0,0,.437,1c.08.131.166.258.255.385l.223.3a6.881,6.881,0,0,0-.067.892,6.591,6.591,0,0,0,2.516,5.18,19.509,19.509,0,0,1-.041,4.044c-.029.28-.064.564-.1.844s-.067.465-.105.7a3.233,3.233,0,0,1-1.392-.105,6.564,6.564,0,0,0-.637-.245c-.927-.233-1.873.691-2.791.411a.373.373,0,0,1-.042.127,1.248,1.248,0,0,0-.637-.188,2.324,2.324,0,0,1-1.383-.793l-1.214-1.144a1.341,1.341,0,0,1-.21-.236,1.658,1.658,0,0,1-.147-.392,4.515,4.515,0,0,0-1.176-1.685.8.8,0,0,0-.347-.252.536.536,0,0,0-.159,0,1.411,1.411,0,0,0-.105-.127,3.007,3.007,0,0,0-.264-.268c-.58-.535-.637-.994-1.141-1.593a15.313,15.313,0,0,1-1.192-1.8c-.041-.335-.1-.679-.169-1.026a13.2,13.2,0,0,0-.7-2.326l-.637-1.411-.073.073c-.462-.688-.956-1.064-1.4-.975-.742.153-1.109,1.593-.991,3.476l.255,1.912a.591.591,0,0,0,.035.143,3.526,3.526,0,0,0-.07.688c0,.268.248.465.379.7a1.991,1.991,0,0,1,.318,1.086c-.016.137-.057.268-.064.4a1.545,1.545,0,0,0,.3.828l1.593,2.676.319.561.019.026a1.361,1.361,0,0,0,.427.491,5.834,5.834,0,0,0,.526,1.934c.054.121.115.236.178.35a11.27,11.27,0,0,0,1.5,1.953l.758.851c.749.835,1.5,1.673,2.31,2.444a3.1,3.1,0,0,0,1.032.723,1.169,1.169,0,0,0,1.16-.169v1.185a.666.666,0,0,1,.5,1.048,26.275,26.275,0,0,1-2.358,4.989,10.618,10.618,0,0,1,1.975,1.507,8.882,8.882,0,0,1,1.029,1.392c.029.236.051.468.064.7.236,3.8-1.233,7.567-2.549,11.186a8.715,8.715,0,0,0-.761,3.167,6.206,6.206,0,0,0-.714.513,4.725,4.725,0,0,1,.13,2.02,3.576,3.576,0,0,1-.264,1.274,8.968,8.968,0,0,1-.459.819,12.159,12.159,0,0,0-1.173,4.849c-.1,1,.29,2.23-.166,3.129a12.8,12.8,0,0,0-1.593,4.9,4.917,4.917,0,0,1-.147,1.144c-.1.319-.274.589-.363.9a3.857,3.857,0,0,0-.064,1.274,12.2,12.2,0,0,1-.669,4.5,6.112,6.112,0,0,0-.526,3.524,4.966,4.966,0,0,0-1.348,2.96,4.667,4.667,0,0,1-.1.844,4.112,4.112,0,0,1-.382.812,7.112,7.112,0,0,0-.867,3.823,10.636,10.636,0,0,0-1.717,4.486c-.284,1.59-.408,3.208-.771,4.779-.484,2.077-1.36,4.177-1.533,6.305a4.441,4.441,0,0,0-1.676,3.145,14,14,0,0,1-.736,3.591c-.261.58-.637,1.1-.886,1.692a7.77,7.77,0,0,0-.382,1.456,5.682,5.682,0,0,0-.1,2.389,3.6,3.6,0,0,1-.933.711c.051-.2.092-.4.127-.6-.822.746-2.313.484-2.969,1.38a1.344,1.344,0,0,0,.319,1.845,2.548,2.548,0,0,0,.659.284,10.538,10.538,0,0,0,4.868.752,1.452,1.452,0,0,0,.551-.175,1.774,1.774,0,0,0,.513-.593q.368-.583.733-1.166a15.12,15.12,0,0,0,1.787.417c.061.51.105,1.019.127,1.529.319.064.746.083.9-.213a.774.774,0,0,0,.054-.354c0-.226.032-.526.051-.832h.064a6.055,6.055,0,0,0,2.82-.57c-.341-2.823.784-5.582,1.759-8.252,1.029-2.81,1.912-5.671,2.8-8.532.637-2.013,1.341-3.963,1.966-5.98q1.179-3.823,2.367-7.646c.344-1.121.691-2.23,1.086-3.345a52.108,52.108,0,0,1,2.953-6.573c.319-.6.637-1.2.9-1.822.319-.761.545-1.558.8-2.345a36.294,36.294,0,0,1,2-4.709c.022-.041.038-.08.06-.118.258,1.055.516,2.125.688,3.186a12.108,12.108,0,0,1,.054,3.938,12.985,12.985,0,0,0-.408,2.67,16.484,16.484,0,0,0,1.042,3.578,13.609,13.609,0,0,1,.357,2.74c.089,1.434.867,3.043.319,4.371-1.7,4.209-.879,8.962-1.851,13.381-.5,2.268-2.033,4.4-1.912,6.719q.127,2.469.433,4.926a4.688,4.688,0,0,0,.4,1.494,5.491,5.491,0,0,0,.437.714c-.14.054-.258.2-.36.5a1.965,1.965,0,0,0,.707,2.23,3.1,3.1,0,0,0,.921.319,4.843,4.843,0,0,0,1.332.185,3.094,3.094,0,0,0,.417-.051,15.194,15.194,0,0,0,1.507.542,3.285,3.285,0,0,0,.041.392.488.488,0,0,0,.166.36.5.5,0,0,0,.255.045h1.73V589.6a1.424,1.424,0,0,0,1.1-.357,1.7,1.7,0,0,0,.319-.663q.707-2.4,1.405-4.8a15.352,15.352,0,0,0,.685-5.48c-.615-5.872.736-11.763.3-17.65a42.283,42.283,0,0,1,.542-10.59c.143-.79.319-1.593.382-2.38.14-1.485-.032-2.985.073-4.46.035-.516.105-1.029.169-1.542a74.023,74.023,0,0,0,.685-9.606,30.269,30.269,0,0,0-.2-3.186,1.819,1.819,0,0,0,.87-.51,2.167,2.167,0,0,0,.207-1.36,9.86,9.86,0,0,1,.857-3.256,38.683,38.683,0,0,0,1.2-4.479,15.632,15.632,0,0,0,.535-3.743q0-.191-.019-.382a.989.989,0,0,0,.293-.319,1.848,1.848,0,0,0,.153-.589c.115-.812.233-1.628.347-2.444q.127-.876.252-1.749l1.013-7.07c.086-.615.175-1.227.261-1.838l.264-1.829c.029-.217.06-.433.083-.637C834.642,497.384,833.9,495.651,833.817,494.172Zm-8.453,26.469a5.823,5.823,0,0,1-.637-2.769h-.035a1.421,1.421,0,0,0-.041-.9c-.1-.233-.271-.43-.376-.663a2.424,2.424,0,0,1-.172-.892,24.316,24.316,0,0,1,.456-5.779c.041-.223.086-.449.127-.672a1.669,1.669,0,0,0,.363-.284,2.587,2.587,0,0,0,.411-.637c.36-.723.688-1.459.991-2.208.1-.242.242-.523.487-.583-.051,1.864.14,3.766-.618,5.448a3.452,3.452,0,0,0-.319.86c-.07.475.128.956.057,1.427-.035.245-.14.471-.182.714a.7.7,0,0,0,.185.675.554.554,0,0,0,.137.07c-.019.127-.035.258-.048.382-.026.261-.038.507-.054.659a20.542,20.542,0,0,0-.086,2.345c0,.844.032,1.689.019,2.549a1.731,1.731,0,0,1-.121.723,1.252,1.252,0,0,1-.242.319A8.266,8.266,0,0,0,825.364,520.641Z",
    transform: "translate(-534.175 -328.065)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 1.797,
    cy: 5.088,
    rx: 1.797,
    ry: 5.088,
    transform: "matrix(0.98, -0.201, 0.201, 0.98, 261.735, 143.621)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M878.188,837.008a1.929,1.929,0,0,0,.707,2.208,3.149,3.149,0,0,0,.914.319,4.825,4.825,0,0,0,1.328.182c.551-.026,1.08-.242,1.631-.319a.255.255,0,0,1,.188.025.271.271,0,0,1,.07.223,8.407,8.407,0,0,0,.07.937.481.481,0,0,0,.166.36.5.5,0,0,0,.255.045h1.727a16.848,16.848,0,0,0-.494-4.5,1.006,1.006,0,0,0-.128-.319,1.055,1.055,0,0,0-.551-.319,3.082,3.082,0,0,0-1.335-.233,3.913,3.913,0,0,0-1.5.733,2.282,2.282,0,0,1-1.7.411C878.965,836.6,878.484,836.122,878.188,837.008Z",
    transform: "translate(-597.35 -578.995)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M794.246,834.209a4.778,4.778,0,0,1-1.743,1.185l-.293.14a.2.2,0,0,0-.1.08.172.172,0,0,0,.032.143,2.061,2.061,0,0,0,2.339.851,1.239,1.239,0,0,0,.513-.268,1.681,1.681,0,0,0,.4-1.026,2.1,2.1,0,0,0-.048-1.176C794.9,833.142,794.736,833.595,794.246,834.209Z",
    transform: "translate(-539.457 -577.595)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M796.694,838.528a.774.774,0,0,1-.054.354c-.15.293-.567.277-.892.214a21.454,21.454,0,0,0-.392-3.218c-.618-.029-1.064.558-1.4,1.083l-.854,1.354a1.763,1.763,0,0,1-.51.593,1.509,1.509,0,0,1-.551.175,10.448,10.448,0,0,1-4.852-.752,2.575,2.575,0,0,1-.66-.28,1.348,1.348,0,0,1-.319-1.842c.659-.892,2.141-.637,2.963-1.376a7.417,7.417,0,0,1-.421,1.52c1.1-.166,1.838-1.172,2.724-1.845a1.676,1.676,0,0,1,.777-.37,1.709,1.709,0,0,1,.637.067,7.476,7.476,0,0,1,2.8,1.38,3.024,3.024,0,0,1,1,1.045A7.737,7.737,0,0,1,796.694,838.528Z",
    transform: "translate(-535.213 -577.988)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 6.582,
    cy: 6.582,
    rx: 6.582,
    ry: 6.582,
    transform: "translate(277.468 139.841)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M914.493,614.873a15.611,15.611,0,0,1-.532,3.724,38.446,38.446,0,0,1-1.2,4.46,9.816,9.816,0,0,0-.851,3.25,2.161,2.161,0,0,1-.21,1.357,1.981,1.981,0,0,1-.93.532,1.163,1.163,0,0,0-.784.7,4.925,4.925,0,0,1-.663-1.459q-.857-2.625-1.593-5.279a.685.685,0,0,1,.045-.637.79.79,0,0,1,.277-.156,2.865,2.865,0,0,0,.883-.567,1.29,1.29,0,0,0,.293-.379,1.716,1.716,0,0,0,.124-.72c0-.844,0-1.685-.022-2.53a21.1,21.1,0,0,1,.089-2.335c0-.153.029-.4.054-.659.048-.5.143-1.08.414-1.274.4-.271,1.615.092,2.074.156.79.108,1.593.236,2.364.385A6.31,6.31,0,0,1,914.493,614.873Z",
    transform: "translate(-617.292 -428.555)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M830.254,506.357c-.255.51-.867.755-1.338,1.077l-1.615,1.109a1.077,1.077,0,0,1-.8.274,1.051,1.051,0,0,1-.6-.557.111.111,0,0,0,0-.026l-.335-.561L823.977,505a1.518,1.518,0,0,1-.3-.822c0-.137.048-.264.061-.4a1.928,1.928,0,0,0-.319-1.083c-.127-.239-.382-.436-.376-.7a2.548,2.548,0,0,1,.178-1.029,2.083,2.083,0,0,1,.7-.746c.15-.108.3-.21.462-.319a.912.912,0,0,1,.277-.127c.264-.054.526.166.793.175,1.15.771,1.593,2.23,2.5,3.282.51.6.561,1.058,1.137,1.593.092.083.182.172.268.264a1.852,1.852,0,0,1,.287.414C829.75,505.774,830.384,506.1,830.254,506.357Z",
    transform: "translate(-560.249 -352.452)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M874.784,507.64a5.933,5.933,0,0,1,.707,3.208,2,2,0,0,1-.277.844,2.729,2.729,0,0,1-2.259.873,1.332,1.332,0,0,0-.981.319.892.892,0,0,0,.061,1.09,2.459,2.459,0,0,0,.975.637,8.633,8.633,0,0,0,4.2.93c.669-.064,1.319-.258,1.985-.357a20.834,20.834,0,0,1,2.186-.121c.867-.032,1.73-.118,2.594-.2l2.288-.226a.509.509,0,0,0,.341-.124c.169-.2-.048-.487-.258-.637-1.214-.9-2.759-1.516-3.45-2.867a16.864,16.864,0,0,1-.653-2.084,17.5,17.5,0,0,1-.758-2.01,13.316,13.316,0,0,1-.105-1.854,2.488,2.488,0,0,0-.637-1.7A2.656,2.656,0,0,0,879,502.8a5.611,5.611,0,0,0-4.225,1.37c-.29.29-.538.637-.838.9s-.707.338-.51.682.586.558.8.86A7.333,7.333,0,0,1,874.784,507.64Z",
    transform: "translate(-592.986 -354.448)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M873.008,529.574a36.2,36.2,0,0,1-1.95,7.178,27.019,27.019,0,0,0-1.147,3.218c-.245.988-.2,2.045-.424,3.036-.28,1.233-.561,2.469-.787,3.712a24.336,24.336,0,0,0-.452,5.767,2.41,2.41,0,0,0,.172.889c.105.229.274.427.373.663a1.592,1.592,0,0,1-.089,1.274,3.689,3.689,0,0,1-.656.994c-2.969.886-6.146.6-9.24.784-2.852.172-5.735.758-8.545.271a6.772,6.772,0,0,1,.669-3.852c1.322-3.61,2.785-7.369,2.549-11.151a11.559,11.559,0,0,0-.15-1.316,17.443,17.443,0,0,1,.847-8.051,13.815,13.815,0,0,0,.363-5.028,9.176,9.176,0,0,1-.022-1.647,2.9,2.9,0,0,1,.6-1.539c0-.022.029-.045.045-.067a.437.437,0,0,1,.239,0h0a.2.2,0,0,0,.159,0l.035-.022a.08.08,0,0,1,.092,0c.073.045.115.2.274.226a6.354,6.354,0,0,0,.71.067,3.833,3.833,0,0,1,.848.121h.038A2.488,2.488,0,0,0,858.8,525a3.285,3.285,0,0,0,.758-.293c.07-.076.51-.147.6-.2.29-.175.226-1,.287-1.335a3.671,3.671,0,0,1,.239-.988,1.682,1.682,0,0,1,1.364-.793,7.26,7.26,0,0,1,1.634.146c1.188.169,2.406.14,3.572.414a2.661,2.661,0,0,0,1.765.076c.146.035.169.163.169.319a2.041,2.041,0,0,1-.089.437c-.2.879.487,1.689,1.125,2.326a3.607,3.607,0,0,0,.94.749c.319.147.637.207.956.366a1.74,1.74,0,0,1,.637.583,2.436,2.436,0,0,1,.363.927A5.543,5.543,0,0,1,873.008,529.574Z",
    transform: "translate(-578.25 -366.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M879.421,536.6a36.2,36.2,0,0,1-1.95,7.178A27.052,27.052,0,0,0,876.324,547c-.245.988-.2,2.045-.424,3.036-.28,1.233-.561,2.469-.787,3.712-.067.038-.137.073-.207.105a4.887,4.887,0,0,1-1.249.4,7.646,7.646,0,0,1-2.332-.076l-4.547-.609c-1.816-.245-3.75-.542-5.1-1.771a10.871,10.871,0,0,1-1.778-2.428,11.563,11.563,0,0,0-.15-1.316A17.441,17.441,0,0,1,860.6,540a13.816,13.816,0,0,0,.363-5.028,9.189,9.189,0,0,1-.022-1.647,2.9,2.9,0,0,1,.6-1.539,2.271,2.271,0,0,1,.284-.064h0a1.43,1.43,0,0,1,.194-.026h.092a1.387,1.387,0,0,1,.319.038,5.8,5.8,0,0,1,.637.245h.038a2.44,2.44,0,0,0,.847.121c.421,0,.854-.067,1.274-.1a2.351,2.351,0,0,1,1.51.271,9.057,9.057,0,0,1,.841.768,3.613,3.613,0,0,0,1.061.577,11.276,11.276,0,0,0,8.481-.178,1.661,1.661,0,0,1,.851-.217,1.6,1.6,0,0,1,.612.261c.191.111.379.22.573.319a2.433,2.433,0,0,1,.363.927A5.543,5.543,0,0,1,879.421,536.6Z",
    transform: "translate(-584.645 -373.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M876.311,533.186a17,17,0,0,1-3.632-1.593,1.631,1.631,0,0,0-.612-.261,1.711,1.711,0,0,0-.854.217,11.269,11.269,0,0,1-8.478.178,3.682,3.682,0,0,1-1.061-.577,9.538,9.538,0,0,0-.841-.768c-1.048-.679-2.5.118-3.67-.319a6.472,6.472,0,0,0-.637-.245c-.927-.233-1.87.691-2.781.411a15.488,15.488,0,0,0-.749,2.842,30.977,30.977,0,0,0-.207,3.352c0,.672-.032,1.344,0,2.017a.662.662,0,0,1,.5,1.045,26.113,26.113,0,0,1-2.351,4.973,10.814,10.814,0,0,1,1.969,1.5c1.115,1.179,1.663,2.832,2.867,3.922,1.357,1.227,3.291,1.526,5.1,1.768l4.547.609a7.77,7.77,0,0,0,2.335.08,4.914,4.914,0,0,0,1.246-.4,2.231,2.231,0,0,0,.695-.459,2.55,2.55,0,0,0,.411-.637c.36-.72.688-1.456.991-2.2.105-.265.264-.573.551-.6,1.689-1.523,3.282-3.084,4.97-4.607a11.012,11.012,0,0,0,1.813-1.912c.838-1.239.077-2.995,0-4.492a5.675,5.675,0,0,0-.143-1.137C878.015,534.808,877.371,533.508,876.311,533.186Z",
    transform: "translate(-578.68 -372.495)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M836.364,517.617c-.255.51-.867.755-1.338,1.077L833.41,519.8a1.077,1.077,0,0,1-.8.274,1.051,1.051,0,0,1-.6-.557v-.229a2.136,2.136,0,0,1,.1-.761,2.374,2.374,0,0,1,.714-.918,5.843,5.843,0,0,1,2.093-1.274.718.718,0,0,1,.382-.038.508.508,0,0,1,.14.06,1.853,1.853,0,0,1,.287.414C835.86,517.033,836.494,517.355,836.364,517.617Z",
    transform: "translate(-566.34 -363.664)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M841.012,521.415a2.322,2.322,0,0,1-1.38-.79l-1.208-1.121a1.128,1.128,0,0,1-.21-.236,1.652,1.652,0,0,1-.147-.392,4.494,4.494,0,0,0-1.172-1.682.764.764,0,0,0-.347-.249.7.7,0,0,0-.385.038,5.829,5.829,0,0,0-2.093,1.274,2.38,2.38,0,0,0-.714.918,2.122,2.122,0,0,0-.1.761,5.851,5.851,0,0,0,.554,2.434c.054.118.115.236.178.35a11.032,11.032,0,0,0,1.5,1.947l.758.848c.746.835,1.491,1.669,2.3,2.437a3.04,3.04,0,0,0,1.032.72,1.153,1.153,0,0,0,1.185-.191,1.716,1.716,0,0,0,.338-.605,11.914,11.914,0,0,0,.984-3.973,14.959,14.959,0,0,0-.07-1.647C841.965,521.676,841.554,521.45,841.012,521.415Z",
    transform: "translate(-567.101 -363.993)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M836.415,639.6a73.633,73.633,0,0,1-.682,9.58c-.064.513-.134,1.026-.169,1.539-.105,1.488.067,2.982-.073,4.46-.073.8-.239,1.593-.379,2.374a42.2,42.2,0,0,0-.542,10.562c.44,5.872-.908,11.747-.3,17.6a14.225,14.225,0,0,1-.188,3.406,14.438,14.438,0,0,1-.494,2.058q-.7,2.393-1.4,4.779a1.657,1.657,0,0,1-.319.663,1.51,1.51,0,0,1-1.195.354,13.782,13.782,0,0,1-5.238-1.625,1.826,1.826,0,0,1-.526-.319c-.347-.36-.319-.927-.472-1.4a13.327,13.327,0,0,0-.8-1.408,4.6,4.6,0,0,1-.347-1.45q-.319-2.447-.433-4.913c-.121-2.313,1.408-4.441,1.912-6.691.956-4.422.147-9.163,1.845-13.359.535-1.325-.242-2.931-.318-4.358a13.826,13.826,0,0,0-.357-2.734,16.948,16.948,0,0,1-1.039-3.568,13.122,13.122,0,0,1,.4-2.66,11.956,11.956,0,0,0-.054-3.928c-.169-1.07-.427-2.141-.685-3.186l-.057.118a36,36,0,0,0-2,4.7c-.255.781-.478,1.577-.8,2.335-.261.637-.583,1.22-.9,1.819a52.254,52.254,0,0,0-2.947,6.547c-.4,1.1-.742,2.23-1.086,3.336l-2.361,7.646c-.637,2.01-1.335,3.954-1.959,5.961-.883,2.867-1.765,5.709-2.791,8.513-.956,2.66-2.093,5.416-1.752,8.226a6.053,6.053,0,0,1-2.813.57,16.472,16.472,0,0,1-4.779-1.16,3.715,3.715,0,0,1-1.65-.981c-.707-.863-.532-2.128-.319-3.227a7.807,7.807,0,0,1,.382-1.453c.242-.586.637-1.106.886-1.685a14.135,14.135,0,0,0,.73-3.578,4.414,4.414,0,0,1,1.669-3.138c.175-2.122,1.048-4.215,1.529-6.289.363-1.571.484-3.186.771-4.779a10.5,10.5,0,0,1,1.711-4.476,7.1,7.1,0,0,1,.867-3.823,4.181,4.181,0,0,0,.379-.812,4.664,4.664,0,0,0,.1-.841,4.974,4.974,0,0,1,1.344-2.953,5.993,5.993,0,0,1,.523-3.5,12.177,12.177,0,0,0,.669-4.483,3.928,3.928,0,0,1,.061-1.274c.089-.319.264-.589.366-.9a5.094,5.094,0,0,0,.143-1.144,13.229,13.229,0,0,1,1.593-4.887c.459-.9.07-2.119.166-3.119a12.055,12.055,0,0,1,1.172-4.833c.153-.274.319-.535.456-.819a3.544,3.544,0,0,0,.265-1.274,4.694,4.694,0,0,0-.131-2.014,10.324,10.324,0,0,1,6.248-1.912,38.937,38.937,0,0,0,6.63-.366c.637-.143,1.274-.341,1.947-.436a12.592,12.592,0,0,1,4.581.468,5.457,5.457,0,0,0,.637,2.762A29.654,29.654,0,0,1,836.415,639.6Z",
    transform: "translate(-542.945 -435.43)",
    fill: "#33313f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M885.243,673.29l-3.661,8.233c-.169-1.07-.427-2.141-.685-3.186l-.057.118v-.172l1.994-4.387Z",
    transform: "translate(-599.252 -469.476)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M918.3,614.873a1.376,1.376,0,0,1-.726.271,3.534,3.534,0,0,1-1.192-.162l-2.867-.717a1.417,1.417,0,0,1-.261-.092c.048-.5.143-1.08.414-1.274.4-.271,1.615.092,2.074.156.79.108,1.593.236,2.364.385A6.307,6.307,0,0,1,918.3,614.873Z",
    transform: "translate(-621.087 -428.778)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M920.085,557.635c.061.264.147.526.2.793a6.051,6.051,0,0,1-.067,1.972l-.261,1.822-.261,1.832-1.01,7.051-.248,1.746-.35,2.437a1.757,1.757,0,0,1-.153.586,1.221,1.221,0,0,1-1,.589,3.615,3.615,0,0,1-1.192-.162l-2.867-.72a.9.9,0,0,1-.351-.143.691.691,0,0,1-.185-.672c.041-.242.146-.468.182-.71.07-.472-.127-.956-.057-1.424a3.54,3.54,0,0,1,.319-.857c.956-2.112.4-4.578.726-6.872a10.417,10.417,0,0,1,2.211-4.919,14.119,14.119,0,0,1,2.441-2.4,4.914,4.914,0,0,1,1.373-.956C920.111,556.51,919.99,557.233,920.085,557.635Z",
    transform: "translate(-620.404 -390.624)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M862.233,470.211c-.21.669.118,1.4-.032,2.087-.163.752-.87,1.274-1.071,2.029-.319,1.15.656,2.2,1.37,3.154,2.644,3.549,2.3,8.462,1.392,12.792a66.063,66.063,0,0,1-3.011,10.2,7.814,7.814,0,0,1-1.622,2.845,8.387,8.387,0,0,1,4.492-.436c1.861.516,3.466,2.323,5.353,1.912,1.134-.252,1.931-1.258,2.95-1.816,1.912-1.029,4.215-.382,6.347-.051a2.492,2.492,0,0,0,1.386-.07,2.3,2.3,0,0,0,.841-.774,7.856,7.856,0,0,0,1.638-4.237,5.435,5.435,0,0,0-1.564-4.183,8.95,8.95,0,0,1-1.341-1.274,3.957,3.957,0,0,1-.526-1.931c-.252-3.5.6-7.082-.277-10.472a25.861,25.861,0,0,1-.978-3.6c-.175-1.539.242-3.186-.37-4.594a4.505,4.505,0,0,0-2.686-2.319,14.714,14.714,0,0,0-3.581-.637C869.2,468.682,862.962,467.933,862.233,470.211Z",
    transform: "translate(-584.376 -331.065)",
    fill: "#33313f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775",
    transform: "translate(274.878 138.425)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M867.395,500.4a65.917,65.917,0,0,1-2.995,10.154c.22-.436.4-.9.58-1.351a65.7,65.7,0,0,0,3.011-10.2c.908-4.333,1.255-9.239-1.389-12.792-.637-.847-1.456-1.765-1.427-2.759a3.394,3.394,0,0,0-.542,1c-.319,1.15.656,2.2,1.37,3.154C868.647,491.161,868.3,496.073,867.395,500.4Z",
    transform: "translate(-862.762 -479.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M868.431,473.875a3.1,3.1,0,0,0,.561-1.074,5.457,5.457,0,0,0-.038-1.421,1.533,1.533,0,0,0-.529.73A6.307,6.307,0,0,0,868.431,473.875Z",
    transform: "translate(-865.452 -471.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M881.228,566.9a2.294,2.294,0,0,1-.841.771,2.434,2.434,0,0,1-1.386.07c-2.131-.319-4.461-.975-6.347.054-1.023.554-1.816,1.561-2.953,1.816-1.883.421-3.489-1.386-5.349-1.912a7.468,7.468,0,0,0-4.037.319,5.564,5.564,0,0,1-1.055,1.523,8.387,8.387,0,0,1,4.492-.436c1.861.516,3.466,2.323,5.353,1.912,1.134-.252,1.931-1.259,2.95-1.816,1.912-1.029,4.215-.382,6.347-.051a2.493,2.493,0,0,0,1.386-.07,2.3,2.3,0,0,0,.841-.774,8.565,8.565,0,0,0,1.319-2.523A9.276,9.276,0,0,1,881.228,566.9Z",
    transform: "translate(-859.26 -535.704)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPass);
export default __webpack_public_path__ + "static/media/img-pass.b6d2760e33a11ce03cc38c135dce3a68.svg";
export { ForwardRef as ReactComponent };